import React from 'react';
import InfoItem, { InfoItemProps } from '../info-item/InfoItem';
import * as styles from './InfoList.style';

export interface InfoListProps {
  items: InfoItemProps[],
}

const InfoList: React.FC<InfoListProps> = ({
  items,
}) => (
  <ul>
    {items.map((item) => (
      <li
        key={item.title}
        css={styles.item}
      >
        <InfoItem
          picture={item.picture}
          title={item.title}
          description={item.description}
        />
      </li>
    ))}
  </ul>
);

export default InfoList;
